import script from "./EventItemsSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./EventItemsSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./EventItemsSkeleton.vue?vue&type=style&index=0&id=424481ef&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-424481ef"]])

export default __exports__